import styled from 'styled-components'

export const RoundedChip = styled.div(
  ({ theme }) => `
  display: inline-flex;
  border-radius: ${theme.borderRadius.xLarge}; 
  align-items: center;
  padding: ${theme.spacing.mini} ${theme.spacing.defaultSmall};
  border: 1px solid ${theme.colors.grey.light3};
`
)
